import { CLEAR_ERRORS, GET_ERRORS } from "../Types/types";

// This function was used for returning Error status

export const returnErrors = (dispatch, msg, status) => {
    return dispatch({ type: GET_ERRORS, payload: { msg, status } });
};

// This function was used for Clear Error status

export const clearErrors = () => {
    return {
        type: CLEAR_ERRORS,
    };
};